export default __webpack_public_path__ + "static/media/IFAPME_HOPE_logo.bc8b6963.png";